// test258
(258 && 0);
